import { ImageFragment } from "../../fragments/image";
import { KnowledgeBaseBaseFragment } from "../../fragments/knowledge-base";
import { ResourceHubBaseFragment } from "../resource-hub/resource-hub";
import { gql } from "@apollo/client";

export const QUERY_SEARCH_FETCH_PAGE = gql`
  query fetchSearchPage {
    searchPage {
      title
      yourResultsTitle
      noRecordsFoundText
      placeholder
    }
  }
`;

export const QUERY_FETCH_LATEST_KNOWLEDGE_BASES_WITH_FILTERS = gql`
  query latestKnowledgeBasesWithFilters(
    $filters: KnowledgeBaseFiltersInput
    $limit: Int
    $page: Int
  ) {
    knowledgebases: knowledgeBases_connection(
      filters: $filters
      pagination: { pageSize: $limit, page: $page }
      sort: "publicationDate:desc"
    ) {
      data {
        id
        attributes {
          ...KnowledgeBaseBaseFragment
        }
      }
      meta {
        pagination {
          total
          pageCount
          page
          pageSize
        }
      }
    }
  }
  ${KnowledgeBaseBaseFragment}
  ${ImageFragment}
`;

export const QUERY_FETCH_SEARCH_COURSE_PAGEABLE = gql`
  query fetchSearchCoursesPageable(
    $filters: CourseFiltersInput
    $pagination: PaginationArg
  ) {
    courses: courses_connection(
      pagination: $pagination
      filters: $filters
      status: PUBLISHED
    ) {
      nodes {
        id
        attributes {
          title
          slug
          description
          duration
          thumbnail {
            data {
              ...ImageFragment
            }
          }
          course_category {
            data {
              attributes {
                name
                description
              }
            }
          }
          modules {
            id
            lessons {
              id
              authors {
                data {
                  attributes {
                    name
                    role
                    bio
                    avatar {
                      data {
                        ...ImageFragment
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      pageInfo {
        page
        pageSize
        pageCount
        total
      }
    }
  }
  ${ImageFragment}
`;

export const QUERY_FETCH_SEARCH_RESOURCES = gql`
  query fetchSearchResources(
    $pagination: PaginationArg
    $title: String
    $schoolContextDocumentId: ID!
  ) {
    resources: resources_connection(
      pagination: $pagination
      sort: "publicationDate:desc"
      filters: {
        publishedAt: { notNull: true }
        title: { containsi: $title }
        or: [
          { restrictedSharing: { eq: false } }
          { restrictedSharing: { null: true } }
          {
            restrictedSharing: { eq: true }
            schools: { documentId: { in: [$schoolContextDocumentId] } }
          }
        ]
      }
    ) {
      nodes {
        ...ResourceHubBaseFragment
      }
      pageInfo {
        page
        pageSize
        pageCount
        total
      }
    }
  }
  ${ResourceHubBaseFragment}
`;

export const QUERY_FETCH_SEARCH_UNIFIED = gql`
  query fetchSearchUnified(
    $searchTerm: String
    $contentTypes: [String!]
    $schoolContextDocumentId: ID!
    $page: Int
    $pageSize: Int
  ) {
    searchUnified(
      searchTerm: $searchTerm
      contentTypes: $contentTypes
      schoolContextDocumentId: $schoolContextDocumentId
      page: $page
      pageSize: $pageSize
    ) {
      nodes {
        __typename
        ... on Course {
          documentId
          title
          slug
          description
          duration
          thumbnail {
            data {
              ...ImageFragment
            }
          }
          course_category {
            data {
              attributes {
                name
                description
              }
            }
          }
        }
        ... on KnowledgeBase {
          documentId
          title
          kbSlug: slug
          duration
          knowledgeBaseType {
            data {
              id
              attributes {
                type
              }
            }
          }
          briefDescription
          cover {
            data {
              ...ImageFragment
            }
          }
        }
        ... on Podcast {
          documentId
          title
          podcastSlug: slug
          podcastBriefDescription: briefDescription
          podcastPublicationDate: publicationDate
          podcastCover: cover {
            url
            alternativeText
            mime
          }
          listenings {
            documentId
            listeningTime
            duration
          }
        }
        ... on Resource {
          documentId
          title
          resourceSlug: slug
          resourceBriefDescription: briefDescription
          subHeader
          publicationDate
          resourceStatus
          expireResourceStatusAt
          assetsCount
          type {
            documentId
            type
          }
          category {
            documentId
            category
          }
          resourceCover: cover {
            url
            alternativeText
            mime
          }
        }
      }
      pageInfo {
        page
        pageSize
        pageCount
        total
      }
    }
  }
  ${ImageFragment}
`;
